import { useEffect, useRef } from "react";
import { useAuth } from "../auth/AuthContext";
import {
  SUNBED_TMAX_JOB_POLL_MS,
  completeSunbedTmaxJob,
  failSunbedTmaxJob,
  fetchPendingSunbedTmaxJob,
} from "../services/sunbedTmaxJobs";
import { checkTmaxHealth, startTmaxSession } from "../services/tmax";

/**
 * Polls Salonify for kiosk-enqueued TMAX jobs and runs start on localhost TMAX from the browser.
 * Only claims jobs when the local TMAX service reports ok (avoids remote browsers failing jobs).
 */
export function SunbedTmaxJobPoller() {
  const { user } = useAuth();
  const busy = useRef(false);

  useEffect(() => {
    if (!user?.company?.is_sunbed_tmax) {
      return;
    }
    if (!localStorage.getItem("token")) {
      return;
    }

    const run = async () => {
      if (busy.current) {
        return;
      }
      busy.current = true;
      try {
        let health: { ok?: boolean } | null = null;
        try {
          health = await checkTmaxHealth();
        } catch {
          return;
        }
        if (health?.ok !== true) {
          return;
        }
        const { job } = await fetchPendingSunbedTmaxJob();
        if (!job) {
          return;
        }
        const { id, tmax_id, minutes, delay } = job;
        try {
          await startTmaxSession(tmax_id, minutes, delay);
          await completeSunbedTmaxJob(id);
        } catch (err) {
          const message =
            err instanceof Error ? err.message : "TMAX start failed";
          console.error("Sunbed TMAX job failed:", err);
          try {
            await failSunbedTmaxJob(id, message);
          } catch (reportErr) {
            console.error("Failed to report TMAX job failure:", reportErr);
          }
        }
      } catch (e) {
        console.error("Sunbed TMAX poll error:", e);
      } finally {
        busy.current = false;
      }
    };

    const timer = window.setInterval(run, SUNBED_TMAX_JOB_POLL_MS);
    void run();
    return () => window.clearInterval(timer);
  }, [user?.company?.is_sunbed_tmax]);

  return null;
}
